import {FLEX_PAGE_HEADER_MX, FLEX_PAGE_HEADER_MY} from '@hconnect/common/components'
import {LocationSelectOption} from '@hconnect/common/hproduce/types'
import {PAGE_HEADER_ML} from '@hconnect/uikit/src/lib2/pageContainer/Page'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import {
  Menu,
  MenuItem,
  Typography,
  Breadcrumbs as MUIBreadcrumbs,
  Box,
  SxProps,
  Theme
} from '@mui/material'
import {useMemo, useRef, useState} from 'react'

type AreaSelectBreadcrumbProps = {
  areasOptions: LocationSelectOption[]
  currentAreaId: string | undefined
  onAreaChange: (areaId: string) => void
  sx?: SxProps<Theme>
}

export const AreaSelectBreadcrumbMultiplePermissions = ({
  areasOptions,
  currentAreaId,
  onAreaChange,
  sx
}: AreaSelectBreadcrumbProps) => {
  const [openDropdown, setOpenDropdown] = useState(false)
  const anchorRef = useRef<HTMLSpanElement>(null)

  const handleToggle = () => setOpenDropdown((prev) => !prev)
  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (anchorRef.current?.contains(event.target as HTMLElement)) return
    setOpenDropdown(false)
  }

  const handleMenuItemClick = (areaId: string) => {
    setOpenDropdown(false)
    onAreaChange(areaId)
  }

  const menuOptions = useMemo(() => {
    return areasOptions
      .filter((option) => option.id !== currentAreaId)
      .sort((a, b) => (a.name > b.name ? 1 : -1))
  }, [areasOptions, currentAreaId])

  const selectedAreaName =
    areasOptions.find((option) => option.id === currentAreaId)?.name || 'Select Area'

  return (
    <Box
      component="span"
      display="flex"
      ml={FLEX_PAGE_HEADER_MX + PAGE_HEADER_ML}
      mt={FLEX_PAGE_HEADER_MY}
      sx={sx}
    >
      <MUIBreadcrumbs separator={<b>|</b>}>
        <Typography
          component="span"
          color="common.white"
          ref={anchorRef}
          onClick={handleToggle}
          sx={{cursor: 'pointer'}}
        >
          {selectedAreaName}
          <Box component="span" sx={{ml: 0.5}}>
            {openDropdown ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </Box>
        </Typography>
      </MUIBreadcrumbs>

      <Menu
        anchorEl={anchorRef.current}
        open={openDropdown}
        onClose={handleClose}
        sx={{mt: 1}}
        anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
        transformOrigin={{vertical: 'top', horizontal: 'left'}}
      >
        {menuOptions.map(({id, name}) => (
          <MenuItem key={id} onClick={() => handleMenuItemClick(id)}>
            {name}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  )
}
